import styled from 'styled-components'

export const CapsLockIndicatorWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  padding: 0.4rem 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius[3]};
  font-size: 0.75rem;
  font-weight: 600;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 1;
    }
  }
`
